import { Component, Prop, Ref, Watch, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

import { getMaximumCvvLength } from '@/core/payment-card/utilities/cvv';
import { DEFAULT_CVV_LENGTH } from '../../constants/cvv';

@Component({
    data() {
        return {
            cvv: null,
            cvvLength: DEFAULT_CVV_LENGTH,
            immediateValidation: false
        };
    },
    components: {
        ValidationProvider
    },
    inheritAttrs: false
})
export default class CardCvv extends Vue {
    @Ref() readonly provider!: InstanceType<typeof ValidationProvider>;

    @Prop()
    value: string;

    @Prop()
    label: string;

    @Prop()
    placeholder: string;

    @Prop({ default: 'cardCvv' })
    inputName: string;

    @Prop()
    cardNumber: string;

    @Prop()
    validationMode: string;

    @Prop()
    disabled: boolean;

    @Prop({ type: String, default: '#06A9BF' })
    checkColor: string;

    cvv;
    cvvLength: number;
    immediateValidation: boolean;

    created() {
        this.cvv = this.value;
    }

    @Watch('cvv')
    change(value, oldValue) {
        this.$emit('input', value);
    }

    @Watch('cardNumber', { immediate: true })
    onChangeCardNumber(value, oldValue) {
        this.cvvLength = getMaximumCvvLength(value);
    }

    @Watch('value', { immediate: true })
    onChangeValue(value: string) {
        if (value) {
            this.immediateValidation = true;
        }
    }

    onEnter(e) {
        this.$emit('enter', e);
    }
}
